import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import UserInfo from "./UserInfo";
import Menu from "./Menu";
export default {
  __name: 'NavContainer',
  props: {
    orgInfo: Object
  },
  setup(__props) {
    const store = useStore();
    const collapsed = computed(() => store.state.home.collapsed || false);
    let props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "nav-container",
        style: _normalizeStyle({
          width: collapsed.value ? '90px' : '181px'
        })
      }, [_createVNode(_unref(UserInfo)), _createVNode(_unref(Menu), {
        orgInfo: __props.orgInfo
      }, null, 8, ["orgInfo"])], 4);
    };
  }
};